import React, { useState } from 'react';
import { TextField, Grid, MenuItem, Switch, FormControlLabel, Button } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import styled from 'styled-components';

const FormContainer = styled.div`
  padding: 1rem;
`;

const compressImage = (file, callback) => {
  const reader = new FileReader();
  reader.onload = (event) => {
    const img = new Image();
    img.src = event.target.result;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const maxWidth = 200;
      const maxHeight = 200;
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
      callback(dataUrl);
    };
  };
  reader.readAsDataURL(file);
};

const PersonalInfoForm = ({ data, onChange }) => {
const [profileImage, setProfileImage] = useState(data?.profileImage || '');

  const handleChange = (field) => (event) => {
    onChange({
      ...data,
      [field]: event.target.value
    });
  };

  const handleSalaryTypeChange = (event) => {
    onChange({
      ...data,
      expectedSalary: event.target.checked ? '面议' : ''
    });
  };

  // 处理日期值
  const handleDateChange = (newValue) => {
    onChange({
      ...data,
      availableDate: newValue ? newValue.toISOString() : null
    });
  };

// 将ISO字符串转换为Date对象
    const getDateValue = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      compressImage(file, (compressedImage) => {
        setProfileImage(compressedImage);
        onChange({
          ...data,
          profileImage: compressedImage
        });
      });
    }
  };

  return (
    <FormContainer>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Button
            variant="contained"
            component="label"
          >
            上传头像
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleImageUpload}
            />
          </Button>
          {profileImage && (
            <div style={{ position: 'relative', display: 'inline-block', marginTop: '1rem' }}>
              <img
                src={profileImage}
                alt="Profile"
                style={{ width: '100px', height: '100px', borderRadius: '50%' }}
              />
              <button
                onClick={() => {
                  setProfileImage('');
                  onChange({
                    ...data,
                    profileImage: ''
                  });
                }}
                style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  background: 'red',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ×
              </button>
            </div>
          )}
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="姓名"
            value={data?.name || ''}
            onChange={handleChange('name')}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="邮箱"
            type="email"
            value={data?.email || ''}
            onChange={handleChange('email')}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="电话"
            value={data?.phone || ''}
            onChange={handleChange('phone')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="地址"
            value={data?.address || ''}
            onChange={handleChange('address')}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="工作年限"
            type="number"
            value={data?.workYears || ''}
            onChange={handleChange('workYears')}
            InputProps={{
              endAdornment: '年'
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="求职意向"
            value={data?.jobIntention || ''}
            onChange={handleChange('jobIntention')}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="意向城市"
            value={data?.targetCity || ''}
            onChange={handleChange('targetCity')}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Switch
                checked={data?.expectedSalary === '面议'}
                onChange={handleSalaryTypeChange}
              />
            }
            label="薪资面议"
          />
          {data?.expectedSalary !== '面议' && (
            <TextField
              fullWidth
              label="期望薪资"
              value={data?.expectedSalary || ''}
              onChange={handleChange('expectedSalary')}
              placeholder="例如：15k/月"
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="预期入职时间"
              value={getDateValue(data?.availableDate)}
              onChange={handleDateChange}
              slotProps={{ textField: { fullWidth: true } }}
              clearable
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="个人简介"
            multiline
            rows={4}
            value={data?.summary || ''}
            onChange={handleChange('summary')}
          />
        </Grid>
      </Grid>
    </FormContainer>
  );
};

export default PersonalInfoForm;